import {
  useQuery,
  useMutation,
  UseQueryResult,
  UseMutationResult,
} from "@tanstack/react-query";
import { useChatService } from "../../useAdminServices";
import { ApiResult } from "../../../services/core/types";
import { MarkChatAsReadParams } from "../../../services/admin/types/chat.types";
import { queryKeys } from "../../../lib/react-query/queryClient";

export const useChatUnreadCountQuery = (): UseQueryResult<
  ApiResult<{ count: number }>
> => {
  const chatService = useChatService();

  return useQuery({
    queryKey: queryKeys.chatUnreadCount(),
    queryFn: async () => {
      if (!chatService) {
        throw new Error("Chat service not initialized");
      }
      return chatService.getUnreadCount();
    },
    enabled: !!chatService,
    staleTime: 30 * 1000, // Consider data stale after 30 seconds
    gcTime: 5 * 60 * 1000, // Keep in cache for 5 minutes
    refetchInterval: 30 * 1000, // Refetch every 30 seconds
    refetchIntervalInBackground: true,
  });
};

export const useMarkChatAsReadMutation = (): UseMutationResult<
  ApiResult<void>,
  Error,
  MarkChatAsReadParams
> => {
  const chatService = useChatService();

  return useMutation({
    mutationFn: async (params: MarkChatAsReadParams) => {
      if (!chatService) {
        throw new Error("Chat service not initialized");
      }
      return chatService.markChatAsRead(params);
    },
  });
};
